customElements.define('best-sellers', class extends HTMLElement {
  connectedCallback() {
    const tabs = this.querySelectorAll('[data-tab]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => t.setAttribute('aria-pressed', String(t === tab)));
      this.querySelectorAll('[data-panel]').forEach((p) => (p.hidden = p.dataset.panel !== tab.dataset.tab));
    }));
  }
});
